import React from "react";
import { useClient } from "@adamlip/okeoke.client";

function SimplePayAgreement(props) {
  const { page } = props;

  const { languageCode } = useClient();

  switch (languageCode) {
    case "hu":
      return (
        <div className="simplePay-agreement font-smallest">
          <p className="">
            {`Az ismétlődő bankkártyás fizetés (továbbiakban: „Ismétlődő fizetés”) egy, a SimplePay által
                            biztosított bankkártya elfogadáshoz tartozó funkció, mely azt jelenti, hogy a Vásárló által a
                            regisztrációs tranzakció során megadott bankkártyaadatokkal a jövőben újabb fizetéseket
                            lehet kezdeményezni a bankkártyaadatok újbóli megadása nélkül. Az ismétlődő fizetés ún.
                            „eseti hozzájárulásos” típusa minden tranzakció esetében a Vevő eseti jóváhagyásával
                            történik, tehát, Ön valamennyi jövőbeni fizetésnél jóvá kell, hogy hagyja a tranzakciót. A sikeres
                            fizetés tényéről Ön minden esetben a hagyományos bankkártyás fizetéssel megegyező
                            csatornákon keresztül értesítést kap.
                            Az Ismétlődő fizetés igénybevételéhez jelen nyilatkozat elfogadásával Ön hozzájárul, hogy a
                            sikeres regisztrációs tranzakciót követően jelen webshopban (${
                              page != null ? page : "URL"
                            }) Ön az itt
                            található felhasználói fiókjából kezdeményezett későbbi fizetések a bankkártyaadatok újbóli
                            megadása nélkül menjenek végbe.
                            Figyelem(!): a bankkártyaadatok kezelése a kártyatársasági szabályoknak megfelelően
                            történik. A bankkártyaadatokhoz sem a Kereskedő, sem a SimplePay nem fér hozzá. A
                            Kereskedő által tévesen vagy jogtalanul kezdeményezett ismétlődő fizetéses tranzakciókért
                            közvetlenül a Kereskedő felel, Kereskedő fizetési szolgáltatójával (SimplePay) szemben
                            bármilyen igényérvényesítés kizárt.
                            Jelen tájékoztatót átolvastam, annak tartalmát tudomásul veszem és elfogadom.`}
          </p>
        </div>
      );
    case "en":
      return (
        <div className="simplePay-agreement font-smallest">
          <p className="">
            {`Recurring credit card payment (hereinafter referred to as Recurring payment) is a function
                            included in the acceptance of credit cards provided by SimplePay meaning that in the future
                            it is possible to make payments with credit card details provided by the Customer during the
                            registration transaction without giving credit card details again. One of the types of recurring
                            payment, the so-called “ad-hoc payment” is made with the approval of the Customer during
                            each transaction, so you have to approve all transactions in the case of each future payment.
                            You will receive a notification of the successful payment through channels identical with
                            conventional credit card payments in every case.
                            By accepting this statement to use recurring payment, you allow to make subsequent
                            payments made from your user account in this online store (${
                              page != null ? page : "URL"
                            }) without
                            providing credit card details again after the successful registration.
                            Please note: the processing of credit card details is in accordance with the rules of card issuers.
                            Neither the merchant nor SimplePay has access to the credit card data. The Merchant shall
                            assume direct liability for false or unauthorized recurring payments initiated by the Merchant,
                            any claim enforcement against the Merchant’s payment service provider (SimplePay) shall be
                            unavailable.
                            I have read this notification, I take notice of its content and accept it.`}
          </p>
          <p></p>
        </div>
      );
    default:
      return null;
  }
}

export default SimplePayAgreement;
